import { ProjectName } from '@/config';

export const ogImageFileName: Record<ProjectName, string> = {
  enercity: 'enercity.png',
  ecg: 'eCG.png',
  eeg: 'eEG.png',
  eng: 'eng_v2.png',
  esg: 'eSG.png',
  esol: 'eSOL.png',
};
